import { NetworkStudentLevelModule } from './network-student-level/network-student-level.module';
import { NetworkMidLevelModule } from './network-mid-level/network-mid-level.module';
import { NetworkTopLevelModule } from './network-top-level/network-top-level.module';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { NetworkLeftSideNavComponent } from './network-left-side-nav/network-left-side-nav.component';

@NgModule({
  declarations: [NetworkLeftSideNavComponent],
  imports: [CommonModule, NetworkTopLevelModule, NetworkMidLevelModule, NetworkStudentLevelModule],
  exports: [NetworkLeftSideNavComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class NetworkContainerModule {
  //
}
